import React from "react";
import {CtaWireframeButton, InternalLink} from "../style/itf-styled-components";

const BuyButton = ({className, button}) => {
  return (
    <CtaWireframeButton
      className={className}
      as={InternalLink}
      to={button.to}
    >{button.text}</CtaWireframeButton>
  );
};

export default BuyButton;